module.exports = require("core-js/library/fn/object/get-own-property-descriptor");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs2/core-js/object/get-own-property-descriptor.js
// module id = 217
// module chunks = 0 1